import { Box, Text } from '@wix/design-system';
import React from 'react';
import { STUDIO_HIGHLIGHT_BG_COLOR } from '../../utils/consts';
import s from './TrustBuilders.scss';
const ICON_TILE_SIZE = 'var(--icon-tile-size)';
export const TrustBuilderItem = _ref => {
  let {
    icon,
    title,
    description,
    dataHook,
    pinDescriptionToBottom,
    widthWeight = '1'
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook,
    direction: "horizontal",
    gap: "SP3",
    verticalAlign: "top",
    flex: widthWeight
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.iconTile,
    width: ICON_TILE_SIZE,
    height: ICON_TILE_SIZE,
    backgroundColor: STUDIO_HIGHLIGHT_BG_COLOR,
    align: "center",
    verticalAlign: "middle",
    flexShrink: "0"
  }, icon), /*#__PURE__*/React.createElement(Box, {
    className: s.content,
    direction: "vertical",
    gap: "SP1",
    align: "left",
    textAlign: "left",
    flex: "1",
    height: pinDescriptionToBottom ? ICON_TILE_SIZE : undefined,
    verticalAlign: pinDescriptionToBottom ? 'space-between' : undefined
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold",
    className: s.title
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    className: s.description
  }, description)));
};
//# sourceMappingURL=TrustBuilderItem.js.map